/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mild_Soft_Swan_RestInputs */

const en_mild_soft_swan_rest = /** @type {(inputs: Mild_Soft_Swan_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When enabled, the minimum answer threshold is applied per individual KPI/comment instead of per segment.`)
};

const de_mild_soft_swan_rest = /** @type {(inputs: Mild_Soft_Swan_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn aktiviert, wird der Schwellenwert für Mindestantworten pro einzelnem KPI/Kommentar anstatt pro Segment angewendet.`)
};

/**
* | output |
* | --- |
* | "When enabled, the minimum answer threshold is applied per individual KPI/comment instead of per segment." |
*
* @param {Mild_Soft_Swan_RestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mild_soft_swan_rest = /** @type {((inputs?: Mild_Soft_Swan_RestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mild_Soft_Swan_RestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mild_soft_swan_rest(inputs)
	return de_mild_soft_swan_rest(inputs)
});